"use strict"

import axios from 'axios'

if(localStorage.getItem('apiKey')) {
  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('apiKey');
}

export default axios